export default "__VITE_ASSET__DNghw3Wp__"